import axios from 'axios'
import {AuthModel, UserModel, RespCheckEmail} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const LOCAL_URL = process.env.REACT_APP_LOCALHOST

export const GET_USER_BY_ACCESSTOKEN_URL = `${LOCAL_URL}/verifyToken`
export const LOGIN_URL = `${LOCAL_URL}/verifyAccount`
export const REGISTER_URL = `${LOCAL_URL}/register`
export const SIGNUP_URL = `${LOCAL_URL}`
export const LandingPage_URL = `${LOCAL_URL}/signup`
export const REQUEST_PASSWORD_URL = `${LOCAL_URL}/forgot_password`
export const NewLanding_URL = `${LOCAL_URL}/createAccount`
export const CHECKEMAIL_URL = `${LOCAL_URL}/propertyRequest`
export const GOOGLE_EMAIL_URL = `${LOCAL_URL}/login/?email_id=`
export const GOOGLE_VERIFICATION_URL = `${LOCAL_URL}/login`
export const FORGOT_PASSWORD = `${LOCAL_URL}/forgotPassword`
export const GET_ACCOUNT_TYPE = `${LOCAL_URL}/getAccountType`
export const CONFIRM_LEAD_BOOKING = `${LOCAL_URL}/leads/addLeadBooking`

// export function NewLanding(accouont_holder_name: string,email_id:string,password: string,
// account_verified:string,contact_number:string,country_id:string){
// const headers = {
// 'Content-Type': 'application/json'
// }
// return axios.post<AuthModel>(LandingPage_URL , {
//   accouont_holder_name,
//   email_id,
//   password,
//   account_verified,
//   contact_number,
//   country_id

//   },{
//    headers:headers
//   })

// }

// Server should return AuthModel
export function login(email_id: string, password: string) {
  const headers = {
    'Content-Type': 'application/json',
  }
  return axios.post<AuthModel>(
    LOGIN_URL,
    {
      email_id,
      password,
    },
    {
      headers: headers,
    }
  )
}

export function emailVerification(email_id: string) {
  const params = {email_id: email_id}

  // return  axios.post<AuthModel>(`${LOCAL_URL}/login/?email_id=${email_id}`)
  return axios.post(GOOGLE_VERIFICATION_URL, params)
  // new Promise((resolve, reject) => {

  //.then(res => {
  //     console.log(res);
  //      resolve(res.data)
  //   })
  // })
}

export function signup(name: string, email: string) {
  return axios.post<AuthModel>(SIGNUP_URL, {
    name,
    email,
  })
}

export async function registerPage(
  accouont_holder_name: string,
  email_id: string,
  account_verified: string,
  contact_number: string
) {
  const headers = {
    'Content-Type': 'application/json',
  }
  return await axios.post(
    LandingPage_URL,
    {
      accouont_holder_name,
      email_id,
      // password,
      account_verified,
      contact_number,
    },
    {
      headers: headers,
    }
  )
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function checkEmail() {
  const headers = {
    Authorization: `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`,
  }

  return axios.get<RespCheckEmail>(CHECKEMAIL_URL, {
    headers: headers,
  })
}

export function forgotPassword(email_id: string) {
  return axios.post(FORGOT_PASSWORD, {
    email_id,
  })
}

export async function get_Account_Type(api_token: string) {
  return await axios.get(GET_ACCOUNT_TYPE, {
    headers: {
      Authorization: `Bearer ${api_token}`,
    },
  })
}

interface companyIdImageDataType {
  front: string
  back: string
}
// function to confirm booking by the leads
export async function confirmLeadBooking(
  lead_property_booking_uuid: string,
  fullName: string, // required
  addressLine1: string, // required
  pincode: string, // required
  mobileNumber: string, // required
  depositAmount: string, // required
  monthlyRent: string, // required
  aadhaarCard: companyIdImageDataType[], // required, can be multiple
  addressLine2: string = '',
  city: string = '',
  email: string = '',
  moveInDate: string = '',
  rentAgreementSigningDate: string = '',
  companyName: string = '',
  companyIdImage: companyIdImageDataType | Object = {},
  isPayingNOCCharge: boolean | string = '',
  isPayingLegalCharge: boolean | string = '',
  NOCCharge: number,
  LegalCharge: number,
  administrationCharges?: number,
  brokerageCosts?: number

) {
  return await axios.post(CONFIRM_LEAD_BOOKING, {
    lead_property_booking_uuid,
    fullName, // required
    addressLine1, // required
    pincode, // required
    mobileNumber, // required
    depositAmount, // required
    monthlyRent, // required
    aadhaarCard, // required, can be multiple
    addressLine2,
    city,
    email,
    moveInDate,
    rentAgreementSigningDate,
    companyName,
    companyIdImage,
    isPayingNOCCharge,
    isPayingLegalCharge,
    NOCCharge,
    LegalCharge,
    administrationCharges,
    brokerageCosts,
  })
}
